/**
 * A path of this site to go to after logging in, from the `returnUrl` query
 * parameter an expired email link leaves on home (CredentialsController::
 * redirectExpiredLink()). One leading slash not followed by another slash or
 * a backslash, no backslash, whitespace or control character anywhere, so
 * `//host`, absolute URLs and `javascript:` are refused (mirrors the PHP
 * login form's sameSiteReturnUrl()).
 */
export const safeReturnPath = (value: string | null | undefined): string | null => {
    if (typeof value !== 'string' || value === '') {
        return null;
    }
    // eslint-disable-next-line no-control-regex
    return /^\/(?![/\\])[^\\\s\x00-\x1f\x7f]*$/.test(value) ? value : null;
};
